import { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

export function RepoDashboard() {
  const { org, repo } = useParams<{ org: string; repo: string }>();
  const navigate = useNavigate();
  const [prNumber, setPrNumber] = useState('');

  function handleDrillDown() {
    const n = prNumber.trim();
    if (!n) return;
    navigate(`/repos/${org}/${repo}/pr/${n}`);
  }

  return (
    <div>
      <h2 className="text-lg font-semibold mb-1">
        {org} / {repo}
      </h2>
      <p className="text-sm text-gray-500 mb-6">Per-repo dashboard</p>

      <div className="bg-white border rounded-lg p-6 mb-6">
        <h3 className="text-sm font-semibold text-gray-700 mb-2">Metrics</h3>
        <p className="text-sm text-gray-400">
          TODO: per-repo metrics endpoint. The current <code>/api/scorecard</code> is org-scoped
          only. Will populate once a repo-scoped variant lands.
        </p>
      </div>

      <div className="bg-white border rounded-lg p-6">
        <h3 className="text-sm font-semibold text-gray-700 mb-3">PR drill-down</h3>
        <div className="flex gap-2 items-center">
          <input
            type="number"
            placeholder="PR number"
            value={prNumber}
            onChange={e => setPrNumber(e.target.value)}
            onKeyDown={e => e.key === 'Enter' && handleDrillDown()}
            className="border rounded px-3 py-1.5 text-sm w-36"
          />
          <button
            onClick={handleDrillDown}
            className="bg-blue-600 text-white px-4 py-1.5 rounded text-sm hover:bg-blue-700"
          >
            View PR
          </button>
        </div>
      </div>
    </div>
  );
}
